import { PROMOTION_CONSTRAINTS } from './constraints.js';
import { promotionPercentSchema } from './percent-schema.js';
export const promotionBrandPctSchema = promotionPercentSchema(PROMOTION_CONSTRAINTS.brandPct.label)
    .nullable()
    .optional();
//# sourceMappingURL=promotion-brand-pct-schema.js.map